import { args } from '../common/args';
import { defineCapability } from './internal';
export const TOGGLE_NOTIFICATION_SIDEBAR_CAP = defineCapability({
  name: 'TOGGLE_NOTIFICATION_SIDEBAR_CAP',
  args: {
    isOpen: args.bool()
  }
});